import axios from 'axios'
import VueAxios from 'vue-axios'
import VueApexCharts from 'vue3-apexcharts'
import { createPinia } from 'pinia'
import { createGtm } from '@gtm-support/vue-gtm'
import * as Sentry from '@sentry/vue'
import posthog from 'posthog-js'
import { IS_POSTHOG_ENABLED } from '@/constants/analytics'

import BaseIcon from '@/components/base/BaseIcon.vue'

import App from './App.vue'
import router from './router'
import i18n from './translations'

import 'maz-ui/styles'
import './index.css'
import './input.css'

const app = createApp(App)
const pinia = createPinia()

Sentry.init({
  app,
  dsn: import.meta.env.VITE_SENTRY_URL,
  sendDefaultPii: true,
  debug: import.meta.env.MODE === 'development',
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || 'local',
  integrations: [Sentry.browserTracingIntegration({ router }), Sentry.replayIntegration()],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: import.meta.env.VITE_TRACE_SAMPLE_RATE,
  // Session Replay
  replaysSessionSampleRate: 1.0,
  replaysOnErrorSampleRate: 1.0
})

if (IS_POSTHOG_ENABLED) {
  // Si on recharge en mode assistance (flag persisté en localStorage par useStorage),
  // PostHog démarre opt-out pour ne capturer aucun event interne, même le 1er pageview.
  const isSupportConnection = localStorage.getItem('isSupportConnection') === 'true'
  posthog.init(import.meta.env.VITE_POSTHOG_KEY, {
    api_host: import.meta.env.VITE_POSTHOG_HOST || 'https://eu.i.posthog.com',
    person_profiles: 'identified_only',
    capture_pageview: 'history_change',
    opt_out_capturing_by_default: isSupportConnection
  })
}

app.use(i18n)
app.use(router)
app.use(VueAxios, axios)
app.use(VueApexCharts)
app.use(
  createGtm({
    id: import.meta.env.VITE_GTM_ID,
    queryParams: {
      gtm_auth: import.meta.env.VITE_GTM_AUTH,
      gtm_preview: import.meta.env.VITE_GTM_PREVIEW,
      gtm_cookies_win: 'x'
    },
    enabled: import.meta.env.MODE !== 'development',
    debug: import.meta.env.MODE === 'development',
    vueRouter: router
  })
)
app.use(pinia)

app.component('BaseIcon', BaseIcon)

app.mount('#app')
